const GA_MEASUREMENT_ID: string = process.env.VITE_GA_MEASUREMENT_ID ?? 'G-JZZW6L7JGK';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

export const trackPageView = (path: string, title?: string): void => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_title: title ?? document.title,
    page_location: window.location.href,
    page_path: path,
    send_to: GA_MEASUREMENT_ID,
  });
};

export const trackEvent = (
  action: string,
  category: string,
  label?: string,
  value?: number,
): void => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value,
    send_to: GA_MEASUREMENT_ID,
  });
};

export interface PageSEOMeta {
  title: string;
  description: string;
  ogUrl?: string;
}

const BASE_URL = 'https://www.drivemynt.in';

export const PAGE_SEO_MAP: Record<string, PageSEOMeta> = {
  '/': {
    title: 'DriveMynt - Smart Driving School Management System',
    description:
      'DriveMynt is a comprehensive cloud-based Driving School Management System. Manage students, instructors, vehicles, batches, enrollments, and fees — all in one platform.',
    ogUrl: `${BASE_URL}/`,
  },
  '/pricing': {
    title: 'Pricing - DriveMynt',
    description:
      'Explore DriveMynt subscription plans designed for driving schools of every size. Start with a free trial and scale as you grow.',
    ogUrl: `${BASE_URL}/pricing`,
  },
  '/privacy-policy': {
    title: 'Privacy Policy - DriveMynt',
    description:
      'Read the DriveMynt Privacy Policy to understand how we collect, use, and protect your personal information.',
    ogUrl: `${BASE_URL}/privacy-policy`,
  },
  '/terms-of-service': {
    title: 'Terms of Service - DriveMynt',
    description:
      'Review the DriveMynt Terms of Service governing use of our driving school management platform.',
    ogUrl: `${BASE_URL}/terms-of-service`,
  },
  '/driveMynt-versions': {
    title: 'Release Notes - DriveMynt',
    description:
      'Stay up to date with the latest features, improvements, and bug fixes in DriveMynt.',
    ogUrl: `${BASE_URL}/driveMynt-versions`,
  },
};

const DEFAULT_SEO: PageSEOMeta = {
  title: 'DriveMynt - Smart Driving School Management System',
  description:
    'DriveMynt is a comprehensive cloud-based Driving School Management System.',
  ogUrl: BASE_URL,
};


export const applyPageSEO = (pathname: string): void => {
  const meta = PAGE_SEO_MAP[pathname] ?? DEFAULT_SEO;

  document.title = meta.title;

  const setMeta = (selector: string, content: string): void => {
    const el = document.querySelector<HTMLMetaElement>(selector);
    if (el) el.setAttribute('content', content);
  };

  setMeta('meta[name="description"]', meta.description);
  setMeta('meta[name="title"]', meta.title);
  setMeta('meta[property="og:title"]', meta.title);
  setMeta('meta[property="og:description"]', meta.description);
  if (meta.ogUrl) setMeta('meta[property="og:url"]', meta.ogUrl);
  setMeta('meta[name="twitter:title"]', meta.title);
  setMeta('meta[name="twitter:description"]', meta.description);
  if (meta.ogUrl) setMeta('meta[name="twitter:url"]', meta.ogUrl);

  const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (canonical && meta.ogUrl) canonical.setAttribute('href', meta.ogUrl);
};
